var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "page",
    [
      _c(
        "div",
        { staticClass: "pane-container" },
        [
          _c(_setup.SearchRenderer, {
            attrs: { query: _setup.searchForm, schema: _setup.searchSchema },
            on: { search: _setup.handleSearch, reset: _setup.handleReset },
            scopedSlots: _vm._u([
              {
                key: "search-vipLimit",
                fn: function ({ query }) {
                  return [
                    _c(
                      "el-select",
                      {
                        staticStyle: { width: "100%" },
                        attrs: {
                          multiple: "",
                          placeholder: "全部",
                          clearable: "",
                        },
                        on: { change: _setup.handleVipLevelChange },
                        model: {
                          value: query.vip_limit,
                          callback: function ($$v) {
                            _vm.$set(query, "vip_limit", $$v)
                          },
                          expression: "query.vip_limit",
                        },
                      },
                      [
                        _c("el-option", {
                          attrs: { label: "全部", value: "all" },
                        }),
                        _vm._l(_setup.vipOptions, function (item) {
                          return _c("el-option", {
                            key: item.value,
                            attrs: { label: item.label, value: item.value },
                          })
                        }),
                      ],
                      2
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "pane-container",
          staticStyle: { "margin-top": "12px" },
        },
        [
          _c(
            "div",
            { staticClass: "actions" },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "mini" },
                  on: { click: _setup.handleAddType },
                },
                [_vm._v("新增客服类型")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "mini" },
                  on: { click: _setup.handleAddService },
                },
                [_vm._v("新增客服")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "mini" },
                  on: { click: _setup.handleAdd724Service },
                },
                [_vm._v("7*24小时客服")]
              ),
            ],
            1
          ),
          _c(
            "el-row",
            { attrs: { gutter: 16 } },
            [
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-table",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        data: _setup.typeList,
                        border: "",
                        stripe: "",
                        size: "small",
                        "highlight-current-row": "",
                      },
                      on: { "current-change": _setup.handleTypeCurrentChange },
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          type: "index",
                          label: "序号",
                          width: "60",
                          align: "center",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "type_name",
                          label: "客服类型",
                          "min-width": "120",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "操作",
                          width: "100",
                          fixed: "right",
                          align: "center",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function ({ row }) {
                              return [
                                _c(
                                  "el-button",
                                  {
                                    attrs: { type: "text", size: "small" },
                                    on: {
                                      click: function ($event) {
                                        return _setup.handleEditType(row)
                                      },
                                    },
                                  },
                                  [_vm._v("编辑")]
                                ),
                                _c(
                                  "el-button",
                                  {
                                    staticClass: "danger-button",
                                    attrs: { type: "text", size: "small" },
                                    on: {
                                      click: function ($event) {
                                        return _setup.handleDeleteType(row)
                                      },
                                    },
                                  },
                                  [_vm._v("删除")]
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 16 } },
                [
                  _c(
                    "el-table",
                    {
                      directives: [
                        {
                          name: "loading",
                          rawName: "v-loading",
                          value: _setup.serviceLoading,
                          expression: "serviceLoading",
                        },
                      ],
                      staticStyle: { width: "100%" },
                      attrs: {
                        data: _setup.serviceList,
                        border: "",
                        stripe: "",
                        size: "small",
                        "highlight-current-row": "",
                      },
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          type: "index",
                          label: "序号",
                          width: "60",
                          align: "center",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "name",
                          label: "客服名称",
                          "min-width": "100",
                          "show-overflow-tooltip": "",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "account",
                          label: "客服账号",
                          width: "100",
                          "show-overflow-tooltip": "",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "config_url",
                          label: "配置地址",
                          "min-width": "120",
                          "show-overflow-tooltip": "",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "icon_url",
                          label: "图标",
                          width: "60",
                          align: "center",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function ({ row }) {
                              return [
                                row.icon_url
                                  ? _c("img", {
                                      staticClass: "service-icon-img",
                                      attrs: { src: row.icon_url, alt: "" },
                                    })
                                  : _c("span", [_vm._v("--")]),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "status",
                          label: "状态",
                          width: "80",
                          align: "center",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function ({ row }) {
                              return [
                                _c(
                                  "el-tag",
                                  {
                                    attrs: {
                                      type:
                                        row.status === 1 ? "success" : "info",
                                      size: "small",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          row.status === 1 ? "启用" : "停用"
                                        ) +
                                        " "
                                    ),
                                  ]
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "客服类型",
                          width: "100",
                          "show-overflow-tooltip": "",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function ({ row }) {
                              return [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _setup.typeOptions.find(
                                        (o) => o.value === row.type_id
                                      )?.label || "--"
                                    ) +
                                    " "
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "适用VIP等级",
                          "min-width": "140",
                          "show-overflow-tooltip": "",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function ({ row }) {
                              return [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _setup.formatVipLevels(row.vip_limit)
                                    ) +
                                    " "
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "sort",
                          label: "排序",
                          width: "60",
                          align: "center",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "操作",
                          width: "100",
                          fixed: "right",
                          align: "center",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function ({ row }) {
                              return [
                                _c(
                                  "el-button",
                                  {
                                    attrs: { type: "text", size: "small" },
                                    on: {
                                      click: function ($event) {
                                        return _setup.handleEditService(row)
                                      },
                                    },
                                  },
                                  [_vm._v("编辑")]
                                ),
                                _c(
                                  "el-button",
                                  {
                                    staticClass: "danger-button",
                                    attrs: { type: "text", size: "small" },
                                    on: {
                                      click: function ($event) {
                                        return _setup.handleDeleteService(row)
                                      },
                                    },
                                  },
                                  [_vm._v("删除")]
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        "text-align": "right",
                        "margin-top": "15px",
                      },
                    },
                    [
                      _c("el-pagination", {
                        attrs: {
                          "current-page": _setup.servicePage,
                          "page-sizes": [10, 20, 30, 50],
                          "page-size": _setup.servicePageSize,
                          layout: "total, sizes, prev, pager, next, jumper",
                          total: _setup.serviceTotal,
                        },
                        on: {
                          "size-change": _setup.handleServiceSizeChange,
                          "current-change": _setup.handleServicePageChange,
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(_setup.CustomerServiceTypeDialog, {
        attrs: {
          visible: _setup.typeDialogVisible,
          "dialog-title": _setup.typeDialogTitle,
          "form-data": _setup.currentTypeForm,
        },
        on: {
          "update:visible": function ($event) {
            _setup.typeDialogVisible = $event
          },
          success: _setup.handleTypeDialogSuccess,
        },
      }),
      _c(_setup.CustomerServiceDialog, {
        attrs: {
          visible: _setup.serviceDialogVisible,
          "dialog-title": _setup.serviceDialogTitle,
          "form-data": _setup.currentServiceForm,
          "type-options": _setup.typeOptions,
          "is-on-line-service": _setup.isOnLineService,
        },
        on: {
          "update:visible": function ($event) {
            _setup.serviceDialogVisible = $event
          },
          success: _setup.handleServiceDialogSuccess,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }